import { WebPlugin } from "@capacitor/core";

export class CapacitorNativeGoogleAuthWeb extends WebPlugin {
  async signIn(): Promise<{ idToken: string }> {
    throw this.unimplemented("Google Sign-in is not supported on web by this plugin.");
  }
}
